export default function AcceptInvite() {
    return (
      <div style={{ padding: 20 }}>
        <h2>Accept Invite</h2>
        <p>This page is temporarily restored.</p>
      </div>
    );
  }